import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      refetchInterval: 2 * 60 * 1000,
      refetchOnWindowFocus: true,
      retry: 1
    },
    mutations: {
      retry: 0
    }
  }
});
